<template>
  <div class="flex flex-col">
    <div class="align-middle inline-block min-w-full sm:px-6 lg:px-8">
      <div>
        <form @submit.prevent="fetch()" class="col-12">
          <div class="form-row row text-center">
            <div class="col-11">
              <b-form-input
                type="text"
                name="search"
                id="search"
                v-model="search"
                class="form-control px-2"
                placeholder="Buscar"
              ></b-form-input>
            </div>
            <div class="col-1">
              <button type="submit" class="btn btn-primary px-2">Buscar</button>
            </div>
          </div>
        </form>
        <div v-if="!loading">
          <table
            class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12"
          >
            <thead class="table-active">
              <tr>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4"
                >
                  Nombre
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4"
                >
                  Correo electrónico
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Fecha actualización
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Rol
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-1"
                >
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="item in items" :key="item.id">
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ item.name }}
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ item.email }}
                </td>
                <td
                  :class="`px-6 text-sm text-gray-500 mx-2 ${
                    item.updated ? 'text-left' : 'text-center'
                  }`"
                >
                  {{ dateConvert(item.updated) }}
                </td>
                <td
                  :class="`px-6 text-sm text-gray-500 mx-2 ${
                    item.updated ? 'text-left' : 'text-center'
                  }`"
                >
                  <p>
                    <b>{{ getRoleName(item.role_id) }}</b>
                  </p>
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                  <div class="col-sm-12">
                    <b-dropdown dropleft variant="primary">
                      <template v-slot:button-content>
                        <i class="mdi mdi-eye"></i>
                      </template>
                      <b-dropdown-item :to="{ path: `/forms/editar-rol/${item.id}` }">
                        Editar rol
                      </b-dropdown-item>
                      <b-dropdown-item
                        :to="{ path: `/forms/permissions/${item.id}` }"
                        :disabled="!item.role_id"
                      >
                        Editar permisos
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <Pagination
          ref="paginator"
          @loading="(load) => (loading = load)"
          :search="search"
          @fetch="(data) => (items = data)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RoleAPI from "@/services/role/roleAPI";

import Pagination from "./UserPagination";
import { dateFormat } from "@/utils/helpers/format";

export default {
  components: { Pagination },
  data() {
    return {
      items: [],
      search: "",
      loading: true,

      roles: [],
    };
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      if (date) {
        return dateFormat(date);
      } else {
        return "-";
      }
    },

    getRoles() {
      RoleAPI.getAll()
        .then((response) => {
          let roles = response.Rol.data;

          roles = roles.map((role) => {
            return {
              id: role.id,
              name: role.name.replace("_", " "),
              status: role.status,
            };
          });

          roles = roles.map((role) => {
            return {
              id: role.id,
              name: role.name.replace("ñia", "ñía"),
              status: role.status,
            };
          });

          roles = roles.map((role) => {
            return {
              id: role.id,
              name: role.name.replace("ion", "ión"),
              status: role.status,
            };
          });

          this.roles = roles;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getRoleName(id) {
      return id ? this.roles.find((item) => item.id == id).name : "-";
    },
  },
  mounted() {
    this.getRoles();
  },
};
</script>
